import React from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { FormControl, ModalHeading, Spinner, Textarea } from '@uikit';

import { voteBoxImg } from '@shared/assets/images/scope/projectValidation';

import { VOTE_CHOICE, VoteChoiceValue } from './useVoteStrategy';

interface CastVoteStepProps {
  choice?: VoteChoiceValue;
  reason?: string;
  isVoting?: boolean;
  onReasonChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}

const CastVoteStep = ({
  choice,
  isVoting,
  reason,
  onNext,
  onBack,
  onReasonChange,
}: CastVoteStepProps) => {
  return (
    <>
      <ImageProxy
        className="h-[138px] w-auto mx-auto"
        src={voteBoxImg}
        alt=""
        width={510}
        height={416}
      />

      <ModalHeading>Cast your Vote</ModalHeading>

      <p className="font-medium flex justify-between">
        <span className="text-neutral-500">Choice</span>

        {choice === VOTE_CHOICE.YES ? 'Yes' : 'No'}
      </p>

      <FormControl
        disabled={isVoting}
        Field={Textarea}
        value={reason}
        placeholder="Share your reason (optional)"
        maxLength={400}
        rows={8}
        showLetterCount
        onChange={(event) => onReasonChange(event.target.value)}
      />

      <div className="flex gap-4 mt-4">
        <button
          className={classNames('button button-outline-primary button-lg flex-grow')}
          disabled={isVoting}
          onClick={onBack}
        >
          Back
        </button>
        <button
          className={classNames('button button-solid-primary button-lg flex-grow')}
          disabled={isVoting}
          onClick={onNext}
        >
          {isVoting ? <Spinner size="sm" color="disabled" /> : 'Confirm'}
        </button>
      </div>
    </>
  );
};

export default CastVoteStep;
